export default {
  name: 'smartvoice',
  type: 'layout',
  active: false,
  data: {
    type: 'page',
    url: {},
    pageId: '',
    target: false
  }
}
